import { Pie } from 'vue-chartjs'
import Api from '../../services/Api'
export default {
  extends: Pie,
  props: ['title', 'endpoint', 'filters', 'config'],
  data () {
    return {
			dataset: {},
			isRendered: false
    }
  },
  computed: {
		chartData () {
			return this.dataset
		},
		options () {
			return {
				scales: {
						xAxes: [{
						ticks: {
							beginAtZero: true
						},
						gridLines: {
							display: false
						}
					}]
				},
				legend: {
					display: false
				},
				responsive: true,
				maintainAspectRatio: false,
				labels: {show: false},
				tooltips: this.config.tooltip ? {
					enabled: false,
					custom: (tooltip) => {
						let tooltipEl = document.getElementById('chartjs-tooltip')
						if (!tooltipEl) {
							tooltipEl = document.createElement('div');
							tooltipEl.id = 'chartjs-tooltip';
							document.body.appendChild(tooltipEl);
						}
						if (tooltip.opacity === 0) {
							tooltipEl.style.opacity = 0
							return
						}
						tooltipEl.classList.remove('above', 'below', 'no-transform')
						if (tooltip.yAlign) {
							tooltipEl.classList.add(tooltip.yAlign)
						} else {
							tooltipEl.classList.add('no-transform')
						}

						function getBody(bodyItem) {
							return bodyItem.lines;
						}
						if (tooltip.body) {
							let titleLines = tooltip.title || [];
							let bodyLines = tooltip.body.map(getBody);
							let splitBody = bodyLines[0][0].split(': ')
							let item = {dataLabel: splitBody[0], value: splitBody[1], label: tooltip.title[0]}
							let currentDataset = this.dataset.datasets[0]
							let itemIndex = currentDataset.data.indexOf(parseInt(item.value) ? parseInt(item.value) : item.value)
							let datasetIndex = this.dataset.datasets.indexOf(currentDataset)
							if (this.dataset.tooltips) {
								let tooltipData = this.dataset.tooltips[datasetIndex][itemIndex]
								item = {...item, ...tooltipData}
							}
							let innerHtml = this.config.tooltip
							this.config.tooltipVars.forEach(v => {
								innerHtml = innerHtml.split(`{${v}}`).join(item[v])
							})
							tooltipEl.innerHTML = innerHtml
						}

						let position = this.$data._chart.canvas.getBoundingClientRect()
						tooltipEl.style.opacity = 1
						tooltipEl.style.position = 'absolute'
						tooltipEl.style.left = position.left + window.pageXOffset + tooltip.caretX + 'px'
						tooltipEl.style.top = position.top + window.pageYOffset + tooltip.caretY + 'px'
						tooltipEl.style.fontFamily = tooltip._bodyFontFamily
						tooltipEl.style.fontSize = tooltip.bodyFontSize + 'px'
						tooltipEl.style.fontStyle = tooltip._bodyFontStyle
						tooltipEl.style.padding = tooltip.yPadding + 'px ' + tooltip.xPadding + 'px'
						tooltipEl.style.pointerEvents = 'none'
					}
				} : {
					displayColors: true
				}
			}
		}
	},
  methods: {
		formatDatasets (arr) {
			return {
				labels : arr.labels,
				datasets : [
					{
						data : arr.datasets,
						backgroundColor : arr.colors
					}
				],
				tooltips: arr.tooltips
			}
		},
		getCompanies () {
			let ret = []
			this.filters.companies.forEach(c => {
				ret.push(c.id)
			})
			return ret.join(',')
		},
		getSalesChannels () {
			let ret = []
			this.filters.salesChannels.forEach(c => {
				ret.push(c.value)
			})
			return ret.join(',')
		},
		getData () {
			this.$parent.loading = true
			this.$parent.empty = true
			if (this.isRendered) {
				this.$data._chart.destroy()
			}
			Api().get(`${this.endpoint}?
			start=${this.filters.date.split('#')[0]}
			&end=${this.filters.date.split('#')[1]}
			&companyIdArr=${this.getCompanies()}
			&salesChannels=${this.getSalesChannels()}
			&categories=${this.filters.subcat || this.filters.category}
			&orderDirection=${this.filters.sort}
			&orderField=${this.filters.orderField}
			&brands=${this.filters.brands.join(',')}
			&productIDs=${this.filters.products.join(',')}`)
				.then(res => {
					this.dataset = this.formatDatasets(res.data)
					this.$emit(this.dataset.datasets.length === 0 ? 'noData' : 'yesData')
					this.$emit('finished')
					this.isRendered = true
				}).catch(error => {
					this.$notify({
					  group: 'foo',
					  type: 'error',
					  title: 'Error',
					  text: `Es gab ein Fehler mit Chart ${this.title}`
					});
			})
		}
	},
  mounted () {
		if (this.filters.companies.length > 0 && this.filters.salesChannels.length > 0) {
			this.getData()
		}
  },
  watch: {
		filters () {
			this.getData()
		},
		dataset () {
			this.renderChart(this.dataset, this.options)
		},
  }
}
